import { memo } from 'react';
import { RawHtml, cn } from '@divlab/divanui';

import Img from '@UI/Img';
import Banner from '@Pages/PageCredit/elements/Banner/Banner';
import PartialDetails from './elements/PartialDetails';
import CreditSlimBanner from '@Components/CreditSlimBanner/CreditSlimBanner';
import ServicePageWrapper from '@Components/ServicePageWrapper';
import HowItWork from './elements/HowItWork';
import styles from './PartialPayments.module.css';

import type { PartialData } from './typings';
import type { FC, HTMLAttributes } from 'react';

export interface PartialsProps extends HTMLAttributes<HTMLDivElement> {
  data: PartialData;
}

const PartialPayments: FC<PartialsProps> = (props) => {
  const { data, className } = props;
  const faqBlock = Array.isArray(data.faq) ? data.faq : [data.faq];

  return (
    <div className={cn(styles.container, className)}>
      {data.banner.view === 'slim' && (
        <div id={data.banner.id}>
          <CreditSlimBanner className={styles.bankBanner} banner={data.banner} />
        </div>
      )}

      {data.banner.view === 'fat' && <Banner className={styles.bankBanner} banner={data.banner} />}

      <ServicePageWrapper>
        {data.header && <div className={cn(styles.header, styles.blocksGap)}>{data.header}</div>}
        {data.extraInfo && (
          <div className={styles.extraInfoWrapper}>
            <Img
              cnImage={styles.extraInfoIcon}
              className={styles.extraInfoIconContainer}
              src={data.extraInfo.icon}
            />
            <RawHtml className={styles.extraInfoText} html={data.extraInfo.text} />
          </div>
        )}
      </ServicePageWrapper>

      <ServicePageWrapper>
        <HowItWork className={styles.howItWorkWrapper} data={data.guide} />
      </ServicePageWrapper>

      <ServicePageWrapper>
        {faqBlock.map((faq) => (
          <PartialDetails className={styles.faq} key={faq.title} data={faq} />
        ))}
      </ServicePageWrapper>
    </div>
  );
};

export default memo(PartialPayments);
